import PropTypes from 'prop-types'
import { memo } from 'react'

import {
  CountryOptionRow,
  CountryOptionIcon,
  CountryLabel,
} from './styled-components'

const CountrySelectLabel = ({ FlagIcon, label, size = 16 }) => {
  return (
    <CountryOptionRow>
      {FlagIcon && (
        <CountryOptionIcon>
          <FlagIcon size={size} />
        </CountryOptionIcon>
      )}
      <CountryLabel>{label}</CountryLabel>
    </CountryOptionRow>
  )
}

CountrySelectLabel.propTypes = {
  FlagIcon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  size: PropTypes.number,
}

export default memo(CountrySelectLabel)
